/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeUserStatuses.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   User Status Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const USERSTATUS_LIST_CONTAINER_LOADED = 'USERSTATUS_LIST_CONTAINER_LOADED';
export const USERSTATUS_LIST_CONTAINER_UNLOADED = 'USERSTATUS_LIST_CONTAINER_UNLOADED';
export const USERSTATUS_LIST_TABLE_LOADED = 'USERSTATUS_LIST_TABLE_LOADED';
export const USERSTATUS_LIST_TABLE_UNLOADED = 'USERSTATUS_LIST_TABLE_UNLOADED';
export const USERSTATUS_SELECT_ROW = 'USERSTATUS_SELECT_ROW';
export const USERSTATUS_ADD = 'USERSTATUS_ADD';
export const USERSTATUS_EDIT = 'USERSTATUS_EDIT';
export const USERSTATUS_DELETE = 'USERSTATUS_DELETE';
export const USERSTATUS_OPEN_WARNING = 'USERSTATUS_OPEN_WARNING';
export const USERSTATUS_CLOSE_WARNING = 'USERSTATUS_CLOSE_WARNING';

export const USERSTATUS_EDIT_CONTAINER_LOADED = 'USERSTATUS_EDIT_CONTAINER_LOADED';
export const USERSTATUS_EDIT_CONTAINER_UNLOADED = 'USERSTATUS_EDIT_CONTAINER_UNLOADED';
export const USERSTATUS_EDIT_FORM_LOADED = 'USERSTATUS_EDIT_FORM_LOADED';
export const USERSTATUS_EDIT_FORM_UNLOADED = 'USERSTATUS_EDIT_FORM_UNLOADED';
export const USERSTATUS_EDIT_DATA_LOAD = 'USERSTATUS_EDIT_DATA_LOAD';
export const USERSTATUS_EDIT_CONTAINER_SUBMIT = 'USERSTATUS_EDIT_CONTAINER_SUBMIT';
export const USERSTATUS_EDIT_CONTAINER_CANCEL = 'USERSTATUS_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeUserStatuses.js